import React from "react";
import moment from "moment";

function formatDateDisplay(startDate, endDate, defaultText) {
  let date = "";
  if (!startDate) {
    date = defaultText;
  } else {
    date = startDate.format("Do[, ]MMM[ -- ]")
  }
  if (!endDate) {
    date += defaultText;
  } else {
    date += endDate.format("Do[, ]MMM")
  }
  return date;
}


const SelectedDateRange = ({ startDate, endDate, onClick, showPstDate }) => {
  if (!moment(new Date(startDate)).isValid() && !moment(new Date(endDate)).isValid()) {
    return (
      <div style={{ marginBottom: "30px" }}>
        <input style={{ paddingLeft:"10px",  fontSize: "16px", paddingRight: "20px", cursor: "pointer", fontWeight: "bold", width: "auto", fontFamily:"Open sans, sans-serif" }} onClick={onClick} value={`Select Date`} readOnly />
      </div>
    )
  }
  return (
    <div style={{ marginBottom: "30px" }}>
      <input style={{ paddingLeft:"10px", fontSize: "16px", paddingRight: "20px", cursor: "pointer", fontWeight: "bold", width: "auto", fontFamily:"Open sans, sans-serif" }} onClick={onClick} value={formatDateDisplay(startDate, endDate, "Continue")} readOnly />
    </div>
  )
}
export default SelectedDateRange;
